module.exports = __webpack_public_path__ + "img/Recruiters.11c45ece.svg";